import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Move({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.FILE.MOVE.';
    return (
        <>
            <div className="form-element">
                {t(label + 'SOURCE')}
                <TextInput action={action} inputName="sourceFolder" variables={variables} setOpenVariable={setOpenVariable} filter="string" fieldType="string"
                    displayName={t(label + 'SOURCE')} />
            </div>
            <div className="form-element">
                {t(label + 'DESTINATION')}
                <TextInput action={action} inputName="destinationFolder" variables={variables} setOpenVariable={setOpenVariable} filter="string" fieldType="string"
                    displayName={t(label + 'DESTINATION')} />
            </div>
        </>
    );
}
export default Move;